<template>
  <transition-group name="list">
    <ItemNew v-for="item in items" :key="item.id" :item="item"></ItemNew>
  </transition-group>
</template>

<script>
import categories_nl_json from "../../public/items.json";
import categories_en_json from "../../public/items_en.json";
import categories_tr_json from "../../public/items_tr.json";
import ItemNew from "@/components/ItemNew.vue";

export default {
  name: "Items",
  components: {
    ItemNew,
  },
  data() {
    return {
      items_files: {
        nl: categories_nl_json,
        en: categories_en_json,
        tr: categories_tr_json,
      },
      translations: {},
      triggerItems: 0,
      items: [],
    };
  },

  computed: {
    parents() {
      if (!this.$route.query.parent) return [];
      const parents = this.$route.query.parent.split(",").map(Number);
      return parents;
    },

    reactiveItems() {
      // Should be executed if this.$route.query.lang or this.parents changes
      const react =
        this.$route.query.lang + this.$route.params.id + this.parents.join(",");
      return react;
    },
  },

  watch: {
    reactiveItems() {
      this.triggerItems += 1;
    },
    triggerItems() {
      let categories = JSON.parse(
        JSON.stringify(this.items_files[this.$route.query.lang])
      );

      if (this.parents.length > 0) {
        // Reach the subcategory by following the parents tree
        for (let i = 0; i < this.parents.length; i++) {
          categories = categories.find(
            (cat) => cat.id === this.parents[i]
          ).subCategories;
        }
      }
      const items = categories.find(
        (cat) => cat.id === parseInt(this.$route.params.id)
      ).items;

      this.items = [];
      let index = 0;
      let intervalId = setInterval(() => {
        if (index < items.length) {
          this.items.push(items[index]);
          index++;
        } else {
          clearInterval(intervalId);
        }
      }, 100); // delay in milliseconds
    },
  },

  created() {
    this.triggerItems += 1;
  },
};
</script>

<style scoped>
.list-enter-active {
  -webkit-animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715)
    both;
  animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) both;
}
.list-enter {
  -webkit-animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715)
    both;
  animation: puff-in-center 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) both;
}

@-webkit-keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes puff-in-center {
  0% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-filter: blur(4px);
    filter: blur(4px);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
</style>
